import { QuestionType } from '@/domain/impact/impact.entity';

export interface EnvQuestions {
  [key: string]: EnvQuestion;
}

type I18nText = { fr?: string; en?: string };

export interface EnvQuestion {
  paramId: string;
  topic: EnvTopic;
  section: EnvSection;
  type: QuestionType;
  title: I18nText;
  helpText?: I18nText;
  options?: {
    optionId: string;
    title: I18nText;
  }[];
  fields?: {
    title: I18nText;
  }[];
  dependency?: {
    questions?: Array<string>;
    rules?: Array<{
      conditions: {
        $eq: boolean | string | number;
      };
      value: boolean;
    }>;
  };
}

export type EnvQuestionValue = {
  id: number;
  paramId: string;
  value: string;
  score?: number;
  projectId?: number;
};

export enum EnvSection {
  CO2 = 'CO2',
  CATERING = 'CATERING',
  DISHES = 'DISHES',
  WATER = 'WATER',
  ENERGY = 'ENERGY',
  WASTE_ECODESIGN = 'WASTE_ECODESIGN',
  POLLUTION_LOCATION = 'POLLUTION_LOCATION',
  PHYSICAL_COMMUNICATION = 'PHYSICAL_COMMUNICATION',
  DIGITAL_COMMUNICATION = 'DIGITAL_COMMUNICATION',
  MOBILITY_STRATEGY = 'MOBILITY_STRATEGY',
  PUBLIC_INFORMATION = 'PUBLIC_INFORMATION',
  BEVERAGES = 'BEVERAGES',
  SCENOGRAPHY = 'SCENOGRAPHY',
  WATER_AND_WASTE = 'WATER_AND_WASTE',
  PARTNERSHIP_STRATEGY = 'PARTNERSHIP_STRATEGY',
  TECHNIQUE = 'TECHNIQUE',
}
export enum EnvTopic {
  GLOBAL_CO2 = 'GLOBAL_CO2',
  FOOD_BEVERAGES = 'FOOD_BEVERAGES',
  COMMUNICATION = 'COMMUNICATION',
  RESOURCES_POLLUTION = 'RESOURCES_POLLUTION',
  PUBLIC_ENGAGEMENT = 'PUBLIC_ENGAGEMENT',
  EQUIPMENT_AND_SCENOGRAPHY = 'EQUIPMENT_AND_SCENOGRAPHY',
}
